import { render, staticRenderFns } from "./Distr.vue?vue&type=template&id=883acc3a&scoped=true"
import script from "./Distr.vue?vue&type=script&lang=js"
export * from "./Distr.vue?vue&type=script&lang=js"
import style0 from "./Distr.vue?vue&type=style&index=0&id=883acc3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883acc3a",
  null
  
)

export default component.exports